import styled from "styled-components";

export const StepperWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 250px;
`;

export const StepItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const StepCircle = styled.div<{ isActive: boolean }>`
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: bold;
  border: ${(props) => (props.isActive ? "none" : "1px solid black")};
  color: ${(props) => (props.isActive ? "white" : "black")};
  background-color: ${(props) => (props.isActive ? "#3B82F6" : "#fff")};
`;

export const StepText = styled.span`
  margin-left: 8px;
`;

export const StepLine = styled.div<{ isActive: boolean }>`
  width: 1px;
  height: 24px;
  margin-left: 12px;
  background-color: ${(props) => (props.isActive ? "#3B82F6" : "#D1D5DB")};
`;
